import React from 'react';
import {Scatter} from 'react-chartjs-2';

const ScatterChart = ({ dataValue }) => {
  return <Scatter data={dataValue}/>;
};
export default ScatterChart;
